module.exports = __webpack_public_path__ + "static/media/1.742304df.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/1.png
// module id = 1291
// module chunks = 0